import type { EmployeEntite } from '../entites/employe';
import type { BonTravailEntite } from '../entites/mecanique/bon-travail';

/**
 * Remplit le nom complet (prénom + nom) d'un employé quand il est absent.
 * Permet la recherche par nom complet sur la propriété commune `prenomNom`.
 */
export function enrichirPrenomNomEmploye(employe: EmployeEntite): EmployeEntite {
    if (employe && !employe.prenomNom && (employe.prenom || employe.nom)) {
        employe.prenomNom = `${employe.prenom ?? ''} ${employe.nom ?? ''}`.trim();
    }
    return employe;
}

/**
 * Remplit le nom complet du mécanicien et du contre-maître d'un bon de travail.
 */
export function enrichirPrenomNomBonTravail(bt: BonTravailEntite): BonTravailEntite {
    if (!bt) {
        return bt;
    }
    if (bt.mecanicien) {
        enrichirPrenomNomEmploye(bt.mecanicien);
    }
    if (bt.contreMaitre) {
        enrichirPrenomNomEmploye(bt.contreMaitre);
    }
    return bt;
}

/**
 * Remplit le nom complet du mécanicien et du contre-maître de chaque bon de travail.
 */
export function enrichirPrenomNomBonTravails(bts: BonTravailEntite[]): BonTravailEntite[] {
    if (!bts) {
        return bts;
    }
    bts.forEach(enrichirPrenomNomBonTravail);
    return bts;
}
